import { render, staticRenderFns } from "./CirclePriorityList.vue?vue&type=template&id=821b0794&lang=pug&"
import script from "./CirclePriorityList.vue?vue&type=script&lang=js&"
export * from "./CirclePriorityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports